import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import find from 'lodash/find';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useLagoon } from '../../hooks/useLagoon';
import { StyledDiv, StyledFooterAlignRight } from '../ConstantsStyles';
import {
  guestScheduleModalInfoStyles,
  guestScheduleModalStyles,
} from './ScheduleModal.style';

type GuestScheduleModalProps = {
  isOpen: boolean;
  onSignIn: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

export const GuestScheduleModal = ({
  isOpen,
  onSignIn,
  setIsOpen,
}: GuestScheduleModalProps) => {
  const data = useLagoon('ui-messaging')();
  const { t } = useTranslation();

  const guestStartModalTitle = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION
      .GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_TITLE,
  });
  const guestStartModalDescription = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION
      .GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_DESC,
  });

  return (
    <React.Fragment>
      <ModalDialog
        css={guestScheduleModalStyles}
        data-testid="guest-schedule-modal"
        footer={
          <StyledFooterAlignRight>
            <Layout.Group>
              <Button
                data-testid="guest-close-button"
                onClick={() => setIsOpen(false)}
                variant="outline"
              >
                {t('GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_MODAL.CLOSE_BUTTON')}
              </Button>
              <Button
                data-testid="guest-sign-in-button"
                onClick={() => {
                  onSignIn();
                }}
              >
                {t('GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_MODAL.SIGN_IN_BUTTON')}
              </Button>
            </Layout.Group>
          </StyledFooterAlignRight>
        }
        header={guestStartModalTitle?.message}
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <StyledDiv
          css={guestScheduleModalInfoStyles}
          data-testid="guest-schedule-modal-info"
        >
          {guestStartModalDescription?.message}
        </StyledDiv>
      </ModalDialog>
    </React.Fragment>
  );
};
